import type { FC } from 'react';

import { Tabs, TabsList, TabsTrigger } from '@wwe-portal/ui/components/tabs';
import { cn } from '@wwe-portal/ui/lib/lib';

interface CurrencyTabsProps {
  tabs: {
    content: React.ReactNode;
    value: string;
  }[];
  value: string;
  onChange: (value: string) => void;
  isNew: boolean;
  className?: string;
}
export const CurrencyTabs: FC<CurrencyTabsProps> = ({
  tabs,
  value,
  onChange,
  isNew,
  className,
}) => {
  return (
    <Tabs
      className={cn('relative', className)}
      onValueChange={onChange}
      value={value}
    >
      <TabsList className="bg-back200 border-text700 grid h-[34px] w-full grid-cols-2 rounded-md border border-solid">
        {tabs.map(({ content, value: tabValue }) => (
          <TabsTrigger className="" key={tabValue} value={String(tabValue)}>
            {content}
          </TabsTrigger>
        ))}
      </TabsList>
      {isNew && (
        <div className="absolute -right-[10px] -top-[10px] flex h-6 w-[50px] items-center justify-center rounded bg-[#FF144D] text-xs font-medium text-white">
          NEW
        </div>
      )}
    </Tabs>
  );
};
